import { render, staticRenderFns } from "./StartRegistration.vue?vue&type=template&id=aaa1b314&scoped=true&"
import script from "./StartRegistration.vue?vue&type=script&lang=js&"
export * from "./StartRegistration.vue?vue&type=script&lang=js&"
import style0 from "./StartRegistration.vue?vue&type=style&index=0&id=aaa1b314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa1b314",
  null
  
)

export default component.exports